import React, { Component } from "react";
import PropTypes from "prop-types";
import { withCookies } from "react-cookie";
import { Row, Col, Navbar, Glyphicon } from "react-bootstrap";

import Phi from "../../../Phi/Phi";
import HSGLogo from "../../../Assets/giis.png";
import "./HSGHeader.css";
import "../../../Themes/Generic.css";

import HeaderButton from "../../../Components/HeaderButton";
import HeaderUser from "../../../Components/HeaderUser";
import HeaderDropdown from "../../../Components/HeaderDropdown";

import HeaderAlerts from "../../../Components/HeaderAlerts";
import AlertDropdown from "../../../Components/AlertDropdown";

import HeaderMessage from "../../../Components/HeaderMessage";

import history from "../../../history";
import Constants from "../../../Phi/Constants";

const NAVBAR_MID_POINT = 1199;
const NAVBAR_FLIP_POINT = 767;

class HSGHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: 0,
            height: 0,
        };
    }

    logout() {
        const cookies = this.props.cookies;
        cookies.remove("token", { path: "/" });
        cookies.remove("roles", { path: "/" });

        this.props.logoutUser();
    }

    // Lifecycle Methods ==============================================================

    render() {
        const userProfile = Phi.User.profile();
        const userCustom = Phi.User.userCustomJson();
        const jsonValue = userCustom.json_value;
        return (
            <div ref="header" className="hsg-mh-root">
                <Navbar fluid className="hsg-mh-container">
                    <Row className="show-grid">
                        {/* Navbar Logo and Page Description */}
                        <Col xs={6} sm={2} md={3} lg={3}>
                            <img className="hsg-mh-logo" alt="Health Set Go" src={HSGLogo} style = {{marginTop:'15px'}} />

                            {/* {this.state.width > NAVBAR_MID_POINT && (
                                <span className="hsg-mh-desc">{this.props.heading}</span>
                            )} */}
                        </Col>

                        {/* Navbar Navigation Options */}
                        {this.state.width > NAVBAR_FLIP_POINT && (
                            <Col sm={7} lg={6} style={{ height: this.state.height, display:'flex', justifyContent:'center' }} ref="hsg-school-header-btn">
                                <HeaderButton
                                    text="DASHBOARD"
                                    glyph="dashboard"
                                    onClick={() => this.changeRoute("/dashboard")}
                                    selected={this.props.location.pathname === "/dashboard"}
                                />
                                <HeaderButton
                                    text="STUDENT LIST"
                                    glyph="list"
                                    onClick={() => this.changeRoute("/student-list")}
                                    selected={this.props.location.pathname === "/student-list"}
                                />
                                <HeaderButton
                                    text="INFIRMARY"
                                    glyph="infirmary"
                                    onClick={() => this.changeRoute("/infirmary")}
                                    selected={this.props.location.pathname === "/infirmary"}
                                />
                                <HeaderButton
                                    text="LOCKER"
                                    glyph="locker"
                                    onClick={() => this.changeRoute("/health-locker")}
                                    selected={this.props.location.pathname === "/health-locker"}
                                />
                            </Col>
                        )}

                        {/* Navbar User Image, Name and Account Options */}
                        {this.state.width > NAVBAR_FLIP_POINT && (
                            <Col sm={3} md={3} style={{ height: this.state.height }}>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: 0, marginTop:-6 }}>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                        {Constants.userPermissionMap[this.props.roleType] &&
                                            !!!Constants.userPermissionMap[this.props.roleType].includes(
                                                Constants.userPermissionId.EDIT
                                            ) && (
                                                <HeaderMessage
                                                    count={this.props.unreadMessages}
                                                    onMessageIcon={() => this.props.onMessageIcon()}
                                                />
                                            )}
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                        <HeaderAlerts
                                            bellIcon={
                                                <AlertDropdown
                                                    alertList={(this.props.alerts && this.props.alerts.alerts) || []}
                                                    alertType={"Alerts"}
                                                    onClickAlert={() => null}
                                                />
                                            }
                                            count={this.props.alerts && this.props.alerts.count}
                                            updateAlerts={() => this.props.updateAlerts()}
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" style = {{marginLeft: 10}}>
                                        <HeaderUser name={""} image="#">
                                            <HeaderDropdown
                                                manageProfile
                                                email={userProfile.username}
                                                // onClickManageProfile={() => this.changeRoute("/manage-profile")}
                                                onClickChangePassword={() => this.props.changePassword()}
                                                onClickLogout={() => this.logout()}
                                                onClickSupport={() => this.changeRoute("/support")}
                                                roleType={this.props.roleType}
                                            />
                                        </HeaderUser>
                                    </div>
                                </div>
                            </Col>
                        )}

                        {/* Navbar Options Menu Button (small screens) */}
                        {this.state.width <= NAVBAR_FLIP_POINT && (
                            <Col xs={6} style = {{marginTop :8}}>
                                <div
                                    className="hsg-mh-menu-icon right"
                                    onClick={() => {
                                        this.props.onClickNavDrawer();
                                    }}
                                >
                                    <Glyphicon glyph="menu-hamburger" style = {{color:'#4080FF'}} />
                                </div>
                            </Col>
                        )}
                    </Row>
                </Navbar>
            </div>
        );
    }

    changeRoute(path) {
        history.push(path);
    }

    componentDidMount() {
        this.setState({
            width: window.innerWidth,
            height: this.refs.header.offsetHeight,
        });

        if (Boolean(this.props.setHeaderElement)) {
            this.props.setHeaderElement(this.refs.header);
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.dim.width !== this.props.dim.width) {
            this.setState({
                width: window.innerWidth,
                height: this.refs.header.offsetHeight,
            });
        }
    }

    componentWillUnmount() {}

    // Event Listeners ==============================================

    // Other Methods ================================================

    getHeaderName() {
        /*let profile = Phi.User.profile()
        if (profile) {
            console.log("profile")
            return (
                `${profile.firstname || ''} ${profile.lastname || ''}`
            )
        }*/

        return "John Doe";
    }
}

export default withCookies(HSGHeader);

HSGHeader.propTypes = {
    heading: PropTypes.string.isRequired,
    setHeaderElement: PropTypes.func,
};

HSGHeader.defaultProps = {
    heading: "HEALTH SET GO",
};



// WEBPACK FOOTER //
// ./src/Containers/HSGHeaderContainer/Component/HSGHeader.js